import React from 'react';

const Pagination = ({ currentPage, totalPages, goToPage, total, pageSize = 10 }) => {
  if (totalPages <= 1) return null;

  const from = (currentPage - 1) * pageSize + 1;
  const to = Math.min(currentPage * pageSize, total);

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', flexWrap: 'wrap', gap: '8px' }}>
      <span style={{ fontSize: '13px', color: '#666' }}>
        Showing {from}–{to} of {total}
      </span>
      <div style={{ display: 'flex', gap: '4px' }}>
        <button
          onClick={() => goToPage(1)}
          disabled={currentPage === 1}
          aria-label="First page"
          style={btnStyle(currentPage === 1)}
        >«</button>
        <button
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label="Previous page"
          style={btnStyle(currentPage === 1)}
        >‹</button>
        <span style={{ padding: '4px 10px', fontSize: '13px', lineHeight: '24px' }}>
          {currentPage} / {totalPages}
        </span>
        <button
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label="Next page"
          style={btnStyle(currentPage === totalPages)}
        >›</button>
        <button
          onClick={() => goToPage(totalPages)}
          disabled={currentPage === totalPages}
          aria-label="Last page"
          style={btnStyle(currentPage === totalPages)}
        >»</button>
      </div>
    </div>
  );
};

const btnStyle = (disabled) => ({
  padding: '4px 8px',
  border: '1px solid #dee2e6',
  borderRadius: '4px',
  background: disabled ? '#f8f9fa' : '#fff',
  color: disabled ? '#adb5bd' : '#034659',
  cursor: disabled ? 'not-allowed' : 'pointer',
  fontSize: '14px',
  lineHeight: '24px',
});

export default Pagination;
